<template>
  <div>
    <top title="接单中心" path='/home'></top>
    <div id="mylist">
      <Tabs :value="value" @on-click="changeTabs">
        <TabPane :label="item.label" :name="item.name" v-for="(item, index) in tabs" :key="index">
          <Collapse v-model="value1" accordion v-if="items.length>0">
            <Panel v-for="(item, index) in items" :key="index">
              {{item.user}}
              <span
                style="font-size:12px; float:right;margin-right:16px;color:#999"
              >{{item.companyName}}</span>
              <p slot="content">
                <Row :gutter="16">
                  <div v-if="value!='1'">
                    <template v-if="value=='0'">
                      <Col span="24">
                        <Col class="label" span="7">乘客电话</Col>
                        <Col span="17">{{item.tel==null?'无电话号码':item.tel}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">车牌号</Col>
                        <Col span="17">{{item.carNo}}/{{item.carType==null?'无类型':item.carType}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">出发地点</Col>
                        <Col span="17">{{item.startAdd}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">送达地点</Col>
                        <Col span="17">{{item.endAdd}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">预计用车</Col>
                        <Col span="17">{{item.planUseTime}}</Col>
                      </Col>
                    </template>
                    <template v-if="value=='2'">
                      <Col span="24">
                        <Col class="label" span="7">出发地点</Col>
                        <Col span="17">{{item.startAdd}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">送达地点</Col>
                        <Col span="17">{{item.endAdd}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">总里程</Col>
                        <Col span="17">{{item.mileage==null?'暂无里程':item.mileage+'公里'}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">用车时间</Col>
                        <Col span="17">{{item.realUseTime}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">交车时间</Col>
                        <Col span="17">{{item.realReturnTime}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">用车时长</Col>
                        <Col span="17">{{minToHour(item.duration)}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">计费类型</Col>
                        <Col span="17">{{item.settleType}}</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">费用</Col>
                        <Col span="17">{{item.cost}}元</Col>
                      </Col>
                      <Col span="24">
                        <Col class="label" span="7">评价</Col>
                        <Col span="17">{{item.appraise==null?'暂无评价':item.appraise+'星'}}</Col>
                      </Col>
                    </template>
                  </div>
                  <div v-else>
                    <Steps :current="item.driverStatus-2" direction="vertical">
                      <Step>
                        <p slot="title">接送前往目的地</p>
                        <p slot="content">{{task.startTime}}</p>
                      </Step>
                      <Step>
                        <p slot="title">到达目的地</p>
                        <p slot="content">{{item.endTime==null ? item.endAdd:item.endTime}}</p>
                      </Step>
                      <Step>
                        <p slot="title">返程结束任务</p>
                        <p
                          slot="content"
                        >{{item.realReturnTime==null ? '返程信息暂无':item.realReturnTime}}</p>
                      </Step>
                    </Steps>
                  </div>
                  <Col span="24">
                    <div style="margin:20px 0 10px 0">
                      <Button v-if="value=='0'" type="primary" long @click="start(item)">开始任务</Button>
                      <Row v-if="value=='1'" :gutter="10">
                        <Col span="12">
                          <Button
                            v-if="task.status==1"
                            type="success"
                            long
                            @click="pause(item)"
                          >停车休息</Button>
                          <Button v-if="task.status==0" type="info" long @click="restart(item)">结束休息</Button>
                        </Col>
                        <Col span="12">
                          <Button
                            :disabled="task.status==0"
                            v-if="item.driverStatus==2"
                            type="warning"
                            long
                            @click="toPoint(item)"
                          >送达目的</Button>
                          <Button
                            :disabled="task.status==0"
                            v-if="item.driverStatus==3"
                            type="error"
                            long
                            @click="end(item)"
                          >结束任务</Button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col span="24" v-if="value=='1'">
                    <Col class="label" span="9">{{task.status==1?'累计休息时长':'最近休息时间'}}</Col>
                    <Col span="15">
                      <span v-if="task.status==1">{{minToHour(task.pauseDuration)}}</span>
                      <span v-if="task.status==0">{{task.lastPauseTime}}</span>
                    </Col>
                  </Col>
                </Row>
              </p>
            </Panel>
          </Collapse>
          <p v-else style="margin:50px auto; text-align:center">暂无数据</p>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>
<script>
import top from "../common/top.vue";
import axios from "axios";
export default {
  data() {
    return {
      value: "0", //标签默认展开
      value1: "0", //折叠面板默认展开
      tabs: [
        {
          label: "未进行",
          name: "0"
        },
        {
          label: "任务中",
          name: "1"
        },
        {
          label: "已完成",
          name: "2"
        }
      ],
      items: [],
      task: {
        user: "班超",
        endAdd: "南宁市",
        startTime: "20202020",
        status: ""
      }
    };
  },
  components: {
    top
  },
  methods: {
    getOrders(t) {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("status", t);
      axios({
        method: "post",
        url: "/order/getOrders",
        data: params
      })
        .then(res => {
          this.items = [];
          var data = res.data.data.dataList;
          for (const i in data) {
            var obj = {
              applyId: data[i].applyId,
              companyName: data[i].department.company.companyName,
              user: data[i].user,
              tel: data[i].tel,
              carNo: data[i].car.carNo,
              carType: data[i].carType,
              startAdd: data[i].startAdd,
              endAdd: data[i].endAdd,
              endTime: data[i].endTime, //到达目的地时间
              realUseTime: data[i].realUseTime, //实际用车时间
              realReturnTime: data[i].realReturnTime, //实际交车时间
              planUseTime: data[i].planUseTime,
              pauseDuration: data[i].pauseDuration,
              driverStatus: data[i].driverStatus, //1-未进行，2-开始任务，3-到达目的地，4-结束任务
              mileage: data[i].mileage,
              duration: data[i].duration,
              settleType: data[i].settleType.name,
              cost: data[i].cost,
              appraise: data[i].appraise
            };
            this.items.push(obj);
            //切换到任务中状态时候调用调度操作函数
            if (t == 1) {
              this.getOrderOperate(data[i].applyId);
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    start(row) {
      var params = new URLSearchParams();
      params.append("applyId", row.applyId);

      this.$Modal.confirm({
        title: "你已经接到乘客了么？",
        okText: "接到了",
        cancelText: "还没有",
        content: "接到乘客后才能开始任务，提前点击会扣除出车费",
        onOk: () => {
          axios({
            method: "post",
            url: "/order/orderStart",
            data: params
          }).then(res => {
            this.getOrders(1);
            this.value = "1";
          });
        }
      });
    },
    pause(row) {
      var params = new URLSearchParams();
      params.append("applyId", row.applyId);
      axios({
        method: "post",
        url: "/order/orderPause",
        data: params
      }).then(res => {
        this.getOrderOperate(row.applyId);
      });
    },
    restart(row) {
      var params = new URLSearchParams();
      params.append("applyId", row.applyId);
      axios({
        method: "post",
        url: "/order/orderCancelPause",
        data: params
      }).then(res => {
        this.getOrderOperate(row.applyId);
      });
    },
    toPoint(row) {
      var params = new URLSearchParams();
      params.append("applyId", row.applyId);

      this.$Modal.confirm({
        title: "你已经到达目的地了么？",
        okText: "我到了",
        cancelText: "还没到",
        content: "为了您以及乘客安全。请勿提前点击",
        onOk: () => {
          axios({
            method: "post",
            url: "/order/reachEndAdd",
            data: params
          }).then(res => {
            this.getOrderOperate(row.applyId);
            this.getOrders(1);
          });
        }
      });
    },
    end(row) {
      var params = new URLSearchParams();
      params.append("applyId", row.applyId);
      this.$Modal.confirm({
        title: "你已经返回交车了么？",
        okText: "交车了",
        cancelText: "还没交",
        content: "提前结束会导致您的出车费减少，谨慎操作",
        onOk: () => {
          axios({
            method: "post",
            url: "/order/orderEnd",
            data: params
          }).then(res => {
            this.getOrders(2);
            this.value = "2";
          });
        }
      });
    },
    //点击选项卡触发
    changeTabs(x) {
      this.getOrders(x);
      this.value = x;
    },
    //获取调度操作信息
    getOrderOperate(id) {
      var params = new URLSearchParams();
      params.append("applyId", id);
      axios({
        method: "post",
        url: "/order/getOrderOperate",
        data: params
      }).then(res => {
        var data = res.data.data;
        this.task = {
          status: data.status, //0--暂停 1--开始  2--结束
          user: data.dispatch.user,
          endAdd: data.dispatch.endAdd,
          startTime: data.startTime,
          lastPauseTime: data.lastPauseTime,
          pauseDuration: data.pauseDuration == null ? 0 : data.pauseDuration,
          toPointTime:
            data.dispatch.endTime == null ? 0 : data.dispatch.endTime, //结束时间
          endTime: data.endTime, //结束时间
          totalDuration: data.totalDuration
        };
      });
    },
    //分钟换小时
    minToHour(str) {
      if (str !== "0" && str !== "" && str !== null) {
        return (
          Math.floor(str / 60).toString() +
          "小时" +
          ((str % 60).toString().length < 2
            ? "0" + (str % 60).toString()
            : (str % 60).toString()) +
          "分"
        );
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.getOrders(0);
  }
};
</script>
<style lang="">
.label {
  color: #999;
}
#mylist {
  position: absolute;
  top: 50px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: auto;
  line-height: 2;
}
#mylist::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
#mylist::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #8a8a8a;
}
#mylist::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
/*调整下拉箭头到文字的距离*/
.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header > i {
  transition: transform 0.2s ease-in-out;
  margin-right: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/list/list.vue